__turbopack_context__.v({
  "favoriteNotifier": "FavoritesNotifier-module-scss-module__jHaXHG__favoriteNotifier",
  "favoriteNotifierContent": "FavoritesNotifier-module-scss-module__jHaXHG__favoriteNotifierContent",
  "favoriteNotifierIcon": "FavoritesNotifier-module-scss-module__jHaXHG__favoriteNotifierIcon",
  "favoriteNotifierVisible": "FavoritesNotifier-module-scss-module__jHaXHG__favoriteNotifierVisible",
});
